import React from "react";
import Button from "../button";
import PopUpTypes from "../../constants/popUpTypes";
import lockBodyScroll from "../../helpers/lockBodyScroll";

const PopUp = ({ type, show, onClick, children }) => {
    lockBodyScroll(show);

    let mainButtonLabel = null;
    let secondaryButtonLabel = null;

    switch (type) {
    case PopUpTypes.MESSAGE:
        mainButtonLabel = "Dismiss";
        break;
    case PopUpTypes.ERROR:
        mainButtonLabel = "Understood";
        break;
    case PopUpTypes.CONFIRMATION:
        mainButtonLabel = "Accept";
        secondaryButtonLabel = "Decline";
        break;
    case PopUpTypes.INFORMATION:
        mainButtonLabel = "OK";
        break;
    default:
        break;
    }
    
    return (
        show && (
            <div className="pop-up__overlay">
                <div className="pop-up">
                    <div>{children}</div>
                    <div className="pop-up__buttons">
                        <Button
                            variant="secondary"
                            size="large"
                            onClick={onClick}
                        >
                            {mainButtonLabel}
                        </Button>
                        {secondaryButtonLabel && (
                            <Button
                                variant="secondary"
                                size="large"
                                onClick={onClick}
                            >
                                {secondaryButtonLabel}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        )
    ); 
};

export default PopUp;
